import UxGrowl from '@ux/growl';
import '@ux/growl/dist/styles.css';

export const Growl = UxGrowl;
